import Verso from './Verso';

const VersoContainer = Verso;

VersoContainer.defaultAnswer = () => undefined;

VersoContainer.defaultSolution = () => null;

export default VersoContainer;
